import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    cancel: 'Отмена',
    save: 'Сохранить',
    // Почта
    invalidEmail: 'Введите корректный email',
    sameEmail: 'Это уже ваша почта',
    sendCodeFailed: 'Не удалось отправить код',
    enterCode: 'Введите код из письма',
    emailUpdated: 'Почта обновлена',
    verifyEmailFailed: 'Не удалось подтвердить почту',
    emailTitle: 'Почта аккаунта',
    codePlaceholder: 'Код из письма',
    resendCode: 'Отправить код ещё раз',
    confirm: 'Подтвердить',
    getCode: 'Получить код',
    // Ник
    enterNickname: 'Введите ник',
    profileUnavailable: 'Не удалось получить профиль. Обновите страницу.',
    nicknameUpdated: 'Ник обновлён',
    nicknameUpdateFailed: 'Не удалось обновить ник',
    nicknameTitle: 'Ник автора',
    nicknameHint: 'Это ваше публичное имя: его увидят читатели ваших курсов в академии.',
    // Аватарка
    fileTooBig: (maxKb: number) => `Файл больше ${maxKb} КБ. Выберите другой.`,
    avatarUpdated: 'Аватарка обновлена',
    avatarUploadFailed: 'Не удалось загрузить аватарку',
    avatarTitle: 'Аватарка',
    avatarHint: (maxKb: number) => `JPG или PNG, лучше квадратная, до ${maxKb} КБ.`,
    chooseFile: 'Выбрать файл',
    // Шапка профиля
    changeAvatar: 'Изменить аватарку',
    changeNickname: 'Изменить ник',
    noEmail: 'Почта не указана',
    change: 'Изменить',
    // Кредиты и история
    spendingHistory: 'История расходов',
    seeAll: 'Смотреть все',
    historyLoadFailed: 'Ой, история не загрузилась…',
    nothingHere: 'Ой, тут ничего…',
    spentOn: (amount: string, date: string) => `${amount} потрачено (${date})`,
    refundOn: (amount: string, date: string) => `${amount} возвращено (${date})`,
    paymentsLoadFailed: 'История платежей не загрузилась.',
    retry: 'Повторить',
    noPurchases: 'Ой, а вы ещё не купили ни одного кредита…',
    noPurchasesHint: 'Возьмите первый пакет, и покупки появятся здесь.',
    appLanguage: 'Язык приложения',
    country: 'Страна',
    countryNotSelected: 'Не выбрана',
    countrySearch: 'Найти страну',
    countryEmpty: 'Ничего не найдено',
    countrySaveError: 'Не удалось сохранить страну',
    countryLoadError: 'Не удалось загрузить список стран',
    countryLoading: 'Загрузка…',
    balance: 'Баланс',
    held: (amount: string) => `заморожено ${amount}`,
    topUp: 'Пополнить',
    creditsPackage: 'Пакет кредитов',
    colTime: 'Время',
    colAmount: 'Количество',
    colPrice: 'Цена',
    colStatus: 'Статус',
  },
  en: {
    cancel: 'Cancel',
    save: 'Save',
    invalidEmail: 'Enter a valid email',
    sameEmail: 'This is already your email',
    sendCodeFailed: 'Couldn’t send the code',
    enterCode: 'Enter the code from the email',
    emailUpdated: 'Email updated',
    verifyEmailFailed: 'Couldn’t confirm the email',
    emailTitle: 'Account email',
    codePlaceholder: 'Code from the email',
    resendCode: 'Resend code',
    confirm: 'Confirm',
    getCode: 'Get code',
    enterNickname: 'Enter a nickname',
    profileUnavailable: "Couldn't load your profile. Refresh the page.",
    nicknameUpdated: 'Nickname updated',
    nicknameUpdateFailed: 'Couldn’t update the nickname',
    nicknameTitle: 'Author nickname',
    nicknameHint: 'This is your public name: learners will see it on your courses in Open Academy.',
    fileTooBig: (maxKb: number) => `The file is larger than ${maxKb} KB. Choose another one.`,
    avatarUpdated: 'Avatar updated',
    avatarUploadFailed: 'Couldn’t upload the avatar',
    avatarTitle: 'Avatar',
    avatarHint: (maxKb: number) => `JPG or PNG, preferably square, up to ${maxKb} KB.`,
    chooseFile: 'Choose file',
    changeAvatar: 'Change avatar',
    changeNickname: 'Change nickname',
    noEmail: 'No email set',
    change: 'Change',
    spendingHistory: 'Spending history',
    seeAll: 'See all',
    historyLoadFailed: "Oops, the history didn't load…",
    nothingHere: 'Oops, nothing here…',
    spentOn: (amount: string, date: string) => `${amount} spent (${date})`,
    refundOn: (amount: string, date: string) => `${amount} refunded (${date})`,
    paymentsLoadFailed: "Payment history didn't load.",
    retry: 'Retry',
    noPurchases: "Oops, you haven't bought any credits yet…",
    noPurchasesHint: 'Buy your first package and your purchases will show up here.',
    appLanguage: 'App language',
    country: 'Country',
    countryNotSelected: 'Not selected',
    countrySearch: 'Search country',
    countryEmpty: 'Nothing found',
    countrySaveError: 'Could not save country',
    countryLoadError: 'Could not load the country list',
    countryLoading: 'Loading…',
    balance: 'Balance',
    held: (amount: string) => `${amount} on hold`,
    topUp: 'Top up',
    creditsPackage: 'Credit package',
    colTime: 'Time',
    colAmount: 'Amount',
    colPrice: 'Price',
    colStatus: 'Status',
  },
})
